var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Doughnut,{attrs:{"chart-data":_setup.chartData,"chart-options":_setup.mergedOptions,"plugins":_setup.plugins}})
}
var staticRenderFns = []

export { render, staticRenderFns }